import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { RadPopover } from '../common/RadPopover'
import { RadButton } from '../common/RadButton'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import { RadHeader } from '../common/RadHeader'
import { RadRadioGroup } from '../common/RadRadioGroup'

export function SortPopover ({
  sortOrder,
  loadingCount,
  defaultSort = 'alphabetical',
  onSortChange
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleChange = ({ detail }) => {
    if (onSortChange) {
      // Custom handler for SearchList
      onSortChange(detail.value)
    } else {
      // Default handler for other components
      if (detail.value === defaultSort) {
        searchParams.delete('sort')
      } else {
        searchParams.set('sort', detail.value)
      }
      searchParams.delete('page')
      setSearchParams(searchParams)
    }
  }

  const getDisabledState = (value) => {
    if (loadingCount > 0) { return true }

    // For search-dependent components (like ProjectList)
    if (defaultSort === 'alphabetical') {
      const hasSearch = searchParams.get('search') != null
      if (value === 'relevance') { return !hasSearch }
      if (value === 'alphabetical' || value === 'recent') { return hasSearch }
    }

    return false
  }

  return (
    <RadPopover
      position='bottom'
      size='small'
      triggerType='custom'
      content={
        <RadSpaceBetween size='l'>
          <RadHeader
            variant='h2'
          >
            Sort
          </RadHeader>
          <RadRadioGroup
            onChange={handleChange}
            items={[
              { value: 'alphabetical', label: 'Alphabetical', disabled: getDisabledState('alphabetical') },
              { value: 'relevance', label: 'Relevance', disabled: getDisabledState('relevance') },
              { value: 'recent', label: 'Recently Updated', disabled: getDisabledState('recent') }
            ]}
            value={sortOrder}
          />
        </RadSpaceBetween>
      }
    >
      <RadButton
        className='secondary'
        iconAlign='right'
        iconName='angle-down'
      >
        Sort
      </RadButton>
    </RadPopover>
  )
}
